import React from 'react'
import Navbar from '../assets/navbar';
import {
  Flex,
  Input,
  Button,
  InputGroup,
  Stack,
  List,
  ListItem,
  ListIcon,
  InputLeftElement,
  chakra,
  Spacer,
  Box,
  OrderedList,
  InputRightElement,
  Alert,
  AlertIcon,
  Image,
  Text,
  Code, 
} from "@chakra-ui/react";




export default function FAQ() {
  const aauColor = "#211a52";
  
  return (
    <>
    <Navbar/>
    <Flex 
        flexDirection="column"
        width="100%"
        height="85vh"
        // justifyContent="center"
        alignItems="center"
        marginBottom="100px"  
        >
      <Box>
        <Text marginBottom="10px"
            fontSize="30px"
            fontWeight="bold"
            color="#211a52"> FAQ</Text>
      </Box>
      <Box mb="10px" maxW="xxl">
      <Text>On this page all of your questions concerning the use of Malware in a Box will hopefully be answered.</Text>
      <Text marginTop="10px" marginBottom="10px" fontSize="30px" color="#211a52"> What kind of malware is included in the provided boxes?</Text>
      <Text>The answer to that question will be written here. </Text>
      <Text marginTop="10px" marginBottom="10px" fontSize="30px" color="#211a52"> Next question </Text>
      <Text>The answer to that question will be written here. </Text>
      <Text marginTop="10px" marginBottom="10px" fontSize="30px" color="#211a52"> Third question </Text>
      <Text>The answer to that question will be written here. code inline: <Code colorScheme="blue">Test</Code> </Text>
      <Text>code blocks:  </Text>
      <Box bg="blue.100" borderRadius='lg'>
      <Code colorScheme="blue" display="block" whiteSpace="pre" children={`
      const initialState: UserState = {
        username : '',
        loggedIn : false,
        firstName : '',
        lastName : '',
        status : 'idle',
        error : ''
    }
      `}/>
      </Box>
      

      </Box>

      </Flex>
    </>
  )
}
